@if (
  proposal.statusPropostaId != 1 &&
  proposal.statusPropostaId != 5 &&
  proposal.statusPropostaId != 6 &&
  proposal.statusPropostaId != 9
) {
  <div class="mb-4">
    <service-additional-proposal-form-edit
      (response)="responseForm($event)"
      [editItem]="item"
      [idProposal]="idProposal"
    ></service-additional-proposal-form-edit>
  </div>
  <mat-divider></mat-divider>
}
<div>
  <!--  <form-client-search-->
  <!--    [search]="inputSearchAddress"-->
  <!--    [listSearch]="listSearch"-->
  <!--    (responseSearch)="search($event)"-->
  <!--  />-->
  @if (!loading) {
    <div class="tab-overflow">
      <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
        @for (column of columns; track column.keyColumn) {
          <ng-container matColumnDef="{{ column.keyColumn }}">
            <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
            <td mat-cell *matCellDef="let element">
              @if (column.keyColumn == 'action') {
                <div class="flex justify-center items-center gap-3">
                  @if (column.key.edit) {
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="edit"
                      (click)="updateItem(element)"
                    />
                  }
                  @if (column.key.duplicate) {
                    @if (loadingDuplicate) {
                      <mat-spinner
                        diameter="24"
                        matTooltip="Duplicando"
                      ></mat-spinner>
                    } @else {
                      <mat-icon
                        class="btn-icon-outline"
                        fontIcon="library_add"
                        (click)="duplicateItem(element)"
                      />
                    }
                  }
                  @if (column.key.delete) {
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="delete"
                      (click)="deleteItem(element)"
                    />
                  }
                </div>
              } @else if (column.keyColumn == 'date') {
                <div class="flex gap-2 items-center">
                  {{ element[column.key] }}
                  @if (!checkdate(element[column.key])) {
                    <mat-icon
                      [matTooltip]="'A data diverge com a data da proposta.'"
                      fontIcon="info"
                      class="alert-icon"
                    ></mat-icon>
                  }
                </div>
              } @else {
                {{ element[column.key] }}
              }
            </td>
          </ng-container>
        }
        <tr
          mat-header-row
          class="style-header"
          *matHeaderRowDef="displayedColumns"
        ></tr>
        <tr
          mat-row
          class="style-row"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>
  } @else {
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
  <mat-paginator
    [hidden]="loading"
    #paginator
    [pageSize]="5"
    (page)="pageChanged($event)"
  >
  </mat-paginator>
</div>
